<template lang="html">
    <div id="app" v-if="doneLoading">
        <v-map :zoom="zoom" :center="center">
            <v-tilelayer :url="url" :attribution="attribution"></v-tilelayer>
            <div v-for="item in markers">
                <v-marker :lat-lng="item.coordinates" :icon="item.icon">
                    <v-popup :content="item.popup"></v-popup>
                    <!-- <v-popup :xcontent="item.popup">
                        <h4 class="text-center">{{item.value.bookingTypeNavn}}</h4>
                        <p>
                            <b>Adresse:</b><br />
                            {{item.value.adresse.vejnavn}} {{item.value.adresse.husnummer}}
                            <span v-if="item.value.adresse.etage === null || item.value.adresse.etage === undefined || item.value.adresse.etage === ''"></span>
                            <span v-else>{{item.value.adresse.etage}}</span>
                            <span v-if="item.value.adresse.doer === null || item.value.adresse.doer === undefined || item.value.adresse.doer === ''"></span>
                            <span v-else>{{item.value.adresse.doer}}</span>
                            {{item.value.adresse.postnummer}} {{item.value.adresse.by}}
                        </p>
                        <p>
                            <b>Tidspunkt:</b><br />
                            {{item.value.fratid}} - {{item.value.tiltid}}
                        </p>
                        <p>
                            <b>Kunde:</b><br />
                            {{item.value.kunde.navn}}
                        </p>
                        <a class="button" :href="'/#/projekt/' + item.value.id">Gå til booking</a>
                        <a class="button" @click="generateGoogleMapsLink(item.value.adresse)">Rutevejledning</a>
                    </v-popup> -->
                    <v-tooltip :content="item.tooltip" :options="options"></v-tooltip>
                </v-marker>
            </div>
        </v-map>
    </div>
    <div v-else>
        Henter kort...
    </div>
</template>

<script lang="js">

import Vue from 'vue';
import Vue2Leaflet from 'vue2-leaflet';
import "leaflet/dist/leaflet.css";
import DAL, {mongoObjectId} from './../js/Sync/dal';
import proj4 from 'proj4/dist/proj4-src';
import Proj4js from './../js/proj4js';
import greenCircle from './../assets/image/green-circle.svg';
import redCircle from './../assets/image/red-circle.svg';
import blackCircle from './../assets/image/black-circle.svg';

export default {
    name: 'mapcomponent',
    components: {
        'v-map': Vue2Leaflet.Map,
        'v-tilelayer': Vue2Leaflet.TileLayer,
        'v-popup': Vue2Leaflet.Popup,
        'v-marker': Vue2Leaflet.Marker,
        'v-tooltip': Vue2Leaflet.Tooltip,
    },
    data() {
        return {
            zoom: 14,
            center: [56.129172, 9.219482],
            url: '//{s}.tile.osm.org/{z}/{x}/{y}.png',
            attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors',
            markers: [],
            centerObj: [],
            unfinishedObj: [],
            options: { permanent: true, custom: true, className: 'tooltipBox', custom: true, dashOffset: "" },
            minX: null,
            maxX: null,
            minY: null,
            maxY: null,
            doneLoading: false
        }
    },
    methods: {
        async init () {
            this.doneLoading = false
            let marker = []
            let items = []
            let user = JSON.parse(this.$cookie.get('user'))

            const promiseIterateTempData = DAL.iterate('MTTempData', (value, key, iterationNumber) => {
                if (value.montoerId === user.id) {
                    let date = moment(value.fratid).format('YYYYMMDD')

                    if (window['selectedDate'] !== null) {
                        if (date.includes(window['selectedDate'])) {
                            items.push(value)
                        }
                    } else {
                        let now = moment(new Date()).format('YYYYMMDD')

                        if (date.includes(now)) {
                            items.push(value)
                        }
                    }
                }
            })

            try {
                await promiseIterateTempData

                const promiseIterateTasks = DAL.iterate('MTTasks', (value, key, iterationNumber) => {
                    var date = moment(value.fratid).format('YYYYMMDD')
                    var selected = ''

                    if (value.montoerId == user.id) {
                        if (window['selectedDate'] !== null && window['selectedDate'] !== '') {
                            selected = window['selectedDate']
                        } else {
                            selected = moment(new Date()).format('YYYYMMDD')
                        }

                        if (date.includes(selected)) {
                            var tempItems = items
                            var existsBool = false
                            tempItems.forEach(function (item) {
                                if (item.id === value.id) {
                                    existsBool = true
                                }
                            });

                            if(!existsBool) {
                                items.push(value)
                                existsBool = false
                            }
                        }
                    }
                })

                try {
                    await promiseIterateTasks
                    let cookie = this.$cookie.get('apikey')

                    try {
                        // const promiseCurrentPosition = new Promise((resolve, reject) => {
                        //     navigator.geolocation.getCurrentPosition(position => {
                        //         resolve(position.coords)
                        //     })
                        // })

                        // const currentPosition = await promiseCurrentPosition

                        console.log('step 1: result', items)
                        // console.log('currentPosition', currentPosition)

                        let result = items.sort((a, b) => {
                            return new Date(a.fratid) - new Date(b.fratid)
                        })

                        for (let i in result) {
                            let value = result[i]

                            if (value.adresse.koordinater === null) {
                                console.log('koordinat er null')
                            } else if (value.adresse.koordinater.x === null || value.adresse.koordinater.y === null || value.adresse.koordinater.x === 0 || value.adresse.koordinater.y === 0) {
                                console.log('koordinat er null')
                            } else {
                                let x = value.adresse.koordinater.x
                                let y = value.adresse.koordinater.y
                                let popupContent = ''

                                Proj4js.defs['EPSG:4326'] = '+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs'
                                Proj4js.defs['EPSG:25832'] = '+title=  ETRF89 / UTM zone 32N EPSG:25832 +proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs'

                                let source = new Proj4js.Proj('EPSG:25832')
                                let dest = new Proj4js.Proj('EPSG:4326')
                                let point = new Proj4js.Point(x, y)

                                Proj4js.transform(source, dest, point)

                                popupContent = '<h4 class="text-center">' + value.bookingTypeNavn + '</h4>'
                                popupContent += '<b>Adresse:</b> <br />' + value.adresse.vejnavn + ' ' + value.adresse.husnummer
                                if (value.adresse.etage == null || value.adresse.etage == undefined || value.adresse.etage == '') {
                                    // No data
                                } else {
                                    popupContent += '. ' + value.adresse.etage
                                }
                                if (value.adresse.doer == null || value.adresse.doer == undefined || value.adresse.doer == '') {
                                    // No data
                                } else {
                                    popupContent += ' - ' + value.adresse.doer
                                }
                                popupContent += ', ' + value.adresse.postnummer + ' ' + value.adresse.by
                                popupContent += '<br />'
                                popupContent += '<b>Tidspunkt:</b> <br /> ' + moment(value.fratid).format('HH:mm') + ' - ' + moment(value.tiltid).format('HH:mm')
                                popupContent += '<br />'
                                popupContent += '<b>Kunde:</b>' + '<br />' + value.kunde.navn
                                popupContent += '<br />'
                                popupContent += '<a class="button" href="/#/projekt/' + value.id +'">Gå til booking</a>'
                                // popupContent += `<a class="button" target="_blank" style="margin-top: 0px;" href="https://www.google.com/maps/dir/${currentPosition.latitude},${currentPosition.longitude}/${value.adresse.vejnavn}+${value.adresse.husnummer},+${value.adresse.postnummer}+${value.adresse.by}">Rutevejledning</a>`

                                let setIcon = function(item) {
                                    if (item.maalerStand !== undefined && item.maalerStand !== "" && item.maalerStand !== null) {
                                        return new L.icon({  
                                            iconUrl: greenCircle,
                                            iconSize: [25, 25],
                                            iconAnchor: [12.5, 12.5]
                                        }) 
                                    } else if ((item.nytMaalernummer !== null && item.nytMaalernummer !== "")) {     
                                        return new L.icon({
                                            iconUrl: blackCircle,
                                            iconSize: [25, 25],
                                            iconAnchor: [12.5, 12.5]
                                        })
                                    } else if (item.nytidTypeId > 0) {
                                        return new L.icon({
                                            iconUrl: redCircle,
                                            iconSize: [25, 25],
                                            iconAnchor: [12.5, 12.5]
                                        })
                                    } else {
                                        return new L.icon({
                                            iconUrl: blackCircle,
                                            iconSize: [25, 25],
                                            iconAnchor: [12.5, 12.5]
                                        })
                                    }                                                                   
                                }

                                var iteration = parseInt(i) + 1;

                                marker.push({
                                    coordinates: L.latLng(point.y, point.x), 
                                    popup: popupContent, 
                                    tooltip: iteration.toString(),
                                    icon: setIcon(value),
                                    stroke: false,
                                    weight: 0,
                                    opacity: 1,
                                    nyMaalerStand: value.nyMaalerStand,
                                    nytMaalernummer: value.nytMaalernummer,
                                    sidsteaflaesning: value.sidsteaflaesning,
                                    maalerStand: value.maalerStand,
                                    nytidTypeId: value.nytidTypeId,
                                    value: value
                                })
                            }
                        }

                        if (marker.length > 0) {
                            console.log('if marker.length > 0', marker.length)
                            this.markers = marker

                            for (let i in marker) {
                                if (
                                    marker[i].nyMaalerStand !== null && marker[i].nyMaalerStand !== ""
                                    && marker[i].nytMaalernummer !== null && marker[i].nytMaalernummer !== ""
                                    && marker[i].sidsteaflaesning > 0 && marker[i].sidsteaflaesning !== null && marker[i].sidsteaflaesning !== ""
                                    && marker[i].maalerStand !== undefined && marker[i].maalerStand != "" && marker[i].maalerStand !== null
                                ) {
                                    if (marker[i].nytidTypeId === undefined || marker[i].nytidTypeId === 0) {
                                        this.centerObj.push(marker[i].coordinates)
                                    } else {
                                        // red color
                                    }
                                } else if (marker[i].nytidTypeId > 0) {
                                    // red color
                                } else {
                                    // black color
                                    this.unfinishedObj.push(marker[i].coordinates)
                                }
                            }
                            if (this.unfinishedObj !== [] && this.unfinishedObj[0] !== undefined) {
                                let lat = this.unfinishedObj[0].lat
                                let lng = this.unfinishedObj[0].lng
                                console.log('this.center[lat, lng]', [lat, lng])
                                this.center = [lat, lng]
                            } else {
                                if (this.centerObj != []) {
                                    for (i in this.centerObj) {
                                        if (this.centerObj[i].lat < this.minX || this.minX == null) {
                                            this.minX = this.centerObj[i].lat
                                        }
                                        if (this.centerObj[i].lng < this.minY || this.minY == null) {
                                            this.minY = this.centerObj[i].lng
                                        }
                                        if (this.centerObj[i].lat > this.maxX || this.minX == null) {
                                            this.maxX = this.centerObj[i].lat
                                        }
                                        if (this.centerObj[i].lng > this.maxY || this.minX == null) {
                                            this.maxY = this.centerObj[i].lng
                                        }
                                    }

                                    var calcX = ((this.maxX - this.minX) / 2) + this.minX
                                    var calcY = ((this.maxY - this.minY) / 2) + this.minY
                                    var newCenterObject = [calcX, calcY]

                                    if (newCenterObject !== []) {
                                        console.log('this.center newCenterObject', newCenterObject)
                                        this.center = newCenterObject
                                        this.zoom = 12
                                    } else {
                                        console.log("else")
                                    }
                                } else {
                                    console.log("else wat")
                                }
                            }
                        } else {
                            console.log('else this.center = default')
                            this.center = [56.129172, 9.219482]
                        }
                    } catch (err) {
                        throw err
                    }
                } catch (err) {
                    throw err
                }
            } catch (err) {
                throw err
            }
        },
        generateGoogleMapsLink (adresse) {
            // let windowReference = window.open()
            // new Promise((resolve, reject) => {
            //     navigator.geolocation.getCurrentPosition(position => {
            //         resolve(position)
            //     })
            // }).then(position => {
            //     let url = `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${adresse.vejnavn}+${adresse.husnummer},+${adresse.postnummer}+${adresse.by}`
            //     // windowReference.name = '_blank'
            //     windowReference.location = url
            // })
            navigator.geolocation.getCurrentPosition(position => {
                let url = `https://www.google.com/maps/dir/${position.coords.latitude},${position.coords.longitude}/${adresse.vejnavn}+${adresse.husnummer},+${adresse.postnummer}+${adresse.by}`
                window.open(url, '_blank')
            })
        }
        // init() {
        //     var _this = this;
        //     var marker = [];
        //     var items = [];
        //     var user = JSON.parse(this.$cookie.get('user'));

        //     return new Promise(function (resolve, reject) {

        //         DAL.iterate("MTTempData", function (value, key, iterationNumber) {

        //             if (value.montoerId == user.id) {
        //                 var date = moment(value.fratid).format('YYYYMMDD');

        //                 if (window['selectedDate'] != null) {
        //                     if (date.includes(window['selectedDate'])) {
        //                         items.push(value);
        //                     }
        //                 } else {
        //                     var now = moment(new Date()).format('YYYYMMDD');

        //                     if (date.includes(now)) {
        //                         items.push(value);
        //                     }
        //                 }
        //             }

        //         }).then(function () {
        //             DAL.iterate("MTTasks", function (value, key, iterationNumber) {
        //                 var date = moment(value.fratid).format('YYYYMMDD');
        //                 var selected = '';

        //                 if (value.montoerId == user.id) {
        //                     if (window['selectedDate'] != null) {
        //                         selected = window['selectedDate'];
        //                     } else {
        //                         selected = moment(new Date()).format('YYYYMMDD');
        //                     }

        //                     if (date.includes(selected)) {
        //                         var tempItems = items;
        //                         var existsBool = false;
        //                         tempItems.forEach(function(item){
        //                             if(item.id === value.id){
        //                                 existsBool = true;
        //                             }
        //                         });

        //                         if(!existsBool){
        //                             items.push(value);
        //                             existsBool = false;
        //                         }
        //                     }
        //                 }
        //             }).then(function () {
        //                 resolve(items)
        //             })
        //         })

        //     }).then(function (result) {
        //         return new Promise((resolve, reject) => {
        //             navigator.geolocation.getCurrentPosition(currentPosition => {
        //                 currentPosition = currentPosition.coords
        //                 resolve({position: currentPosition, items: result})
        //             })
        //         })
        //     }).then(function (object) {
        //         return new Promise(function (resolve, reject) {
        //             let result = object.items

        //             result.sort(function(a, b) {
        //                 return new Date(a.fratid) - new Date(b.fratid);
        //             });
                    
        //             for (var i in result) {

        //                 var value = result[i];

        //                 if (value.adresse.koordinater == null ) {
        //                     console.log("koordinat er null");
        //                 } else if (value.adresse.koordinater.x == null || value.adresse.koordinater.y == null || value.adresse.koordinater.x == 0 || value.adresse.koordinater.y == 0) {
        //                     console.log("koordinat er null");
        //                 } else {
        //                     console.log("if coordinates is defined")
        //                     var x = value.adresse.koordinater.x;
        //                     var y = value.adresse.koordinater.y;
        //                     var popupContent = '';

        //                     Proj4js.defs["EPSG:4326"] = "+proj=longlat +ellps=WGS84 +datum=WGS84 +no_defs";
        //                     Proj4js.defs["EPSG:25832"] = "+title=  ETRF89 / UTM zone 32N EPSG:25832 +proj=utm +zone=32 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs"

        //                     var source = new Proj4js.Proj("EPSG:25832");
        //                     var dest = new Proj4js.Proj("EPSG:4326");

        //                     var point = new Proj4js.Point(x, y);

        //                     Proj4js.transform(source, dest, point);

        //                     popupContent = '<h4 class="text-center">' + value.bookingTypeNavn + '</h4>'
        //                     popupContent += '<b>Adresse:</b> <br />' + value.adresse.vejnavn + ' ' + value.adresse.husnummer;
        //                     if (value.adresse.etage == null || value.adresse.etage == undefined || value.adresse.etage == '') {
        //                         // No data
        //                     } else {
        //                         popupContent += '. ' + value.adresse.etage;
        //                     }
        //                     if (value.adresse.doer == null || value.adresse.doer == undefined || value.adresse.doer == '') {
        //                         // No data
        //                     } else {
        //                         popupContent += ' - ' + value.adresse.doer;
        //                     }
        //                     popupContent += ', ' + value.adresse.postnummer + ' ' + value.adresse.by;
        //                     popupContent += '<br />';
        //                     popupContent += '<b>Tidspunkt:</b> <br /> ' + moment(value.fratid).format('HH:mm') + ' - ' + moment(value.tiltid).format('HH:mm');
        //                     popupContent += '<br />';
        //                     popupContent += '<b>Kunde:</b>' + '<br />' + value.kunde.navn;
        //                     popupContent += '<br />';
        //                     popupContent += '<a class="button" href="/#/projekt/' + value.id +'">Gå til booking</a>';
        //                     popupContent += `<a class="button" target="_blank" style="margin-top: 0px;" href="https://www.google.com/maps/dir/${object.position.latitude},${object.position.longitude}/${value.adresse.vejnavn}+${value.adresse.husnummer},+${value.adresse.postnummer}+${value.adresse.by}">Rutevejledning</a>`

        //                     var setIcon = function(item) {
        //                         if (
        //                             item.nyMaalerStand !== null && item.nyMaalerStand !== ""
        //                             && item.nytMaalernummer !== null && item.nytMaalernummer !== ""
        //                             && item.sidsteaflaesning > 0 && item.sidsteaflaesning !== null && item.sidsteaflaesning !== ""
        //                             && item.maalerStand !== undefined && item.maalerStand != "" && item.maalerStand !== null
        //                         ){
        //                             if (item.nytidTypeId === undefined || item.nytidTypeId === 0) {
        //                                 return new L.icon({  
        //                                     iconUrl: greenCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             } else if (item.nytidTypeId > 0) {
        //                                 return new L.icon({
        //                                     iconUrl: redCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             } else {
        //                                 return new L.icon({
        //                                     iconUrl: blackCircle,
        //                                     iconSize: [25, 25],
        //                                     iconAnchor: [12.5, 12.5]
        //                                 })
        //                             }
        //                         } else if (item.nytidTypeId > 0) {
        //                             return new L.icon({
        //                                 iconUrl: redCircle,
        //                                 iconSize: [25, 25],
        //                                 iconAnchor: [12.5, 12.5]
        //                             })
        //                         } else {
        //                             return new L.icon({
        //                                 iconUrl: blackCircle,
        //                                 iconSize: [25, 25],
        //                                 iconAnchor: [12.5, 12.5]
        //                             })
        //                         }
        //                     }

        //                     var iteration = parseInt(i) + 1;

        //                     console.log("value", value)

        //                     marker.push({
        //                         coordinates: L.latLng(point.y, point.x), 
        //                         popup: popupContent, 
        //                         tooltip: iteration.toString(),
        //                         icon: setIcon(value),
        //                         stroke: false,
        //                         weight: 0,
        //                         opacity: 1,
        //                         nyMaalerStand: value.nyMaalerStand,
        //                         nytMaalernummer: value.nytMaalernummer,
        //                         sidsteaflaesning: value.sidsteaflaesning,
        //                         maalerStand: value.maalerStand,
        //                         nytidTypeId: value.nytidTypeId
        //                     })
        //                 }
        //             }
        //             if (marker.length > 0) {
        //                 console.log("if marker.length > 0")

        //                 _this.markers = marker;

        //                 for (i in marker) {
        //                     if (
        //                         marker[i].nyMaalerStand !== null && marker[i].nyMaalerStand !== ""
        //                         && marker[i].nytMaalernummer !== null && marker[i].nytMaalernummer !== ""
        //                         && marker[i].sidsteaflaesning > 0 && marker[i].sidsteaflaesning !== null && marker[i].sidsteaflaesning !== ""
        //                         && marker[i].maalerStand !== undefined && marker[i].maalerStand != "" && marker[i].maalerStand !== null
        //                     ) {
        //                         if (marker[i].nytidTypeId === undefined || marker[i].nytidTypeId === 0) {
        //                             _this.centerObj.push(marker[i].coordinates)
        //                         } else {
        //                             // red color
        //                         }
        //                     } else if (marker[i].nytidTypeId > 0) {
        //                         // red color
        //                     } else {
        //                         // black color
        //                         _this.unfinishedObj.push(marker[i].coordinates)
        //                     }
        //                 }

        //                 if (_this.unfinishedObj !== [] && _this.unfinishedObj[0] !== undefined) {
        //                     console.log("if unfinishedObj != []")
        //                     console.log(_this.unfinishedObj)
        //                     _this.center = _this.unfinishedObj[0];
        //                 } else {

        //                     if (_this.centerObj != []) {
        //                         console.log("if centerObj")
        //                         for (i in _this.centerObj) {
        //                             if (_this.centerObj[i].lat < _this.minX || _this.minX == null) {
        //                                 _this.minX = _this.centerObj[i].lat;
        //                             }
        //                             if (_this.centerObj[i].lng < _this.minY || _this.minY == null) {
        //                                 _this.minY = _this.centerObj[i].lng;
        //                             }
        //                             if (_this.centerObj[i].lat > _this.maxX || _this.minX == null) {
        //                                 _this.maxX = _this.centerObj[i].lat;
        //                             }
        //                             if (_this.centerObj[i].lng > _this.maxY || _this.minX == null) {
        //                                 _this.maxY = _this.centerObj[i].lng;
        //                             }
        //                         }

        //                         var calcX = ((_this.maxX - _this.minX) / 2) + _this.minX;
        //                         var calcY = ((_this.maxY - _this.minY) / 2) + _this.minY;
        //                         var newCenterObject = [calcX, calcY]

        //                         if (newCenterObject !== []) {
        //                             console.log("if newCenterObj")
        //                             _this.center = newCenterObject;
        //                             _this.zoom = 12;
        //                         } else {
        //                             console.log("else")
        //                         }
        //                     } else {
        //                         console.log("else wat")
        //                     }
        //                 }
        //             } else {
        //                 _this.center = [56.129172, 9.219482]
        //             }
        //         });
        //     });
        // }
    },
    mounted() {
        // var _this = this;
        $(document).foundation();
        $('header').show();
        // this.init().then(function (result) {
        //     console.log("init after", result)
        //     if (result.length > 0) {
        //         console.log("result", result);
        //         _this.markers = result;
        //         _this.center = result[0].coordinates;
        //     }
        // });
    },
    async created () {
         try {
            await this.init()
            // let cookie = this.$cookie.get('apikey')
            // if (cookie === 'DBB06AEE-989F-4F9E-847A-DC5C97FAA94A') {
            //     alert(this.center)
            // }
            // this.center = [56.129172, 9.219482]
            this.doneLoading = true
        } catch (err) {
            console.log('error init map', err)
            this.doneLoading = true
        }
    }
}

</script>

<style lang="scss">
    .vue2leaflet-map {
        margin-top: 55px;
    }
    .vue2leaflet-map svg path {
        stroke: transparent !important;
    }

    /* TOOLTIPBOX */

    .tooltipBox {
        // background-color: transparent !important;
        // border: 0px !important;
        // box-shadow: 0 0px !important;
        // color: #fff !important;
        //font-weight: bold !important;
        //font-size: 120% !important;
        //position: absolute !important;
        //left: -7px !important;
        //right: 0 !important;
        //top: -10px !important;
        //bottom:  0 !important;
        //text-align: center !important;
        //vertical-align: middle !important;
        //margin: auto !important;
        //padding: auto !important;
        //display: block !important;
        //transform: translate3d(0px, 0px, 0px);

        &:after {
            // content: '' !important;
            // border: none !important;
            // background-color: transparent !important;
            // position: absolute !important;
            // left: 0 !important;
            // right: 0 !important;
            // top: 0 !important;
            // bottom: 0 !important;
            // width: 20px !important;
            // height: 20px !important;
            text-align: center !important;
        }

        &:before {
            // content: '' !important;
            // border: none !important;
            // background-color: transparent !important;
            // position: absolute !important;
            // left: 0 !important;
            // right: 0 !important;
            // top: 0 !important;
            // bottom: 0 !important;
            // width: 20px !important;
            // height: 20px !important;
            text-align: center !important;
        }
    }

</style>



// WEBPACK FOOTER //
// MapComponent.vue?05a72213